const MessageBusView = () => null;

export default MessageBusView;
